import CommentIcon from '@mui/icons-material/Comment';
import HelpIcon from '@mui/icons-material/Help';
import PassIcon from '@mui/icons-material/Loop';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import { text } from '../../modules/languages/index';
import CancelScheduleSendOutlinedIcon from '@mui/icons-material/CancelScheduleSendOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import SmsIcon from '@mui/icons-material/Sms';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import ContactsIcon from '@mui/icons-material/Contacts';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PollIcon from '@mui/icons-material/Poll';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import PhotoIcon from '@mui/icons-material/Photo';
import InfoIcon from '@mui/icons-material/Info';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CategoryIcon from '@mui/icons-material/Category';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RuleIcon from '@mui/icons-material/Rule';
import LineStyleIcon from '@mui/icons-material/LineStyle';
import AppsIcon from '@mui/icons-material/Apps';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import CalculateIcon from '@mui/icons-material/Calculate';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import TourIcon from '@mui/icons-material/Tour';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import EventNoteIcon from '@mui/icons-material/EventNote';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SmartToyIcon from "@mui/icons-material/SmartToy";
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import TableChartIcon from '@mui/icons-material/TableChart';

const iconPaths = {
  CampaignOutlinedIcon: CampaignOutlinedIcon,
  PendingActionsOutlinedIcon: PendingActionsOutlinedIcon,
  DescriptionOutlinedIcon: DescriptionOutlinedIcon,
  TaskAltOutlinedIcon: TaskAltOutlinedIcon,
  LibraryAddOutlinedIcon: LibraryAddOutlinedIcon,
  LockOpenOutlinedIcon: LockOpenOutlinedIcon,
  LockOutlinedIcon: LockOutlinedIcon,
  PassIcon: PassIcon,
  CancelScheduleSendOutlinedIcon: CancelScheduleSendOutlinedIcon,
  ApartmentIcon: ApartmentIcon,
  PersonIcon: PersonIcon,
  AccessibilityIcon: AccessibilityIcon,
  AssignmentIcon: AssignmentIcon,
  AssessmentIcon: AssessmentIcon,
  CommentIcon: CommentIcon,
  HelpIcon: HelpIcon,
  SmsIcon: SmsIcon,
  MarkAsUnreadIcon: MarkAsUnreadIcon,
  ManageAccountsIcon: ManageAccountsIcon,
  BadgeIcon: BadgeIcon,
  SettingsPhoneIcon: SettingsPhoneIcon,
  ContactEmergencyIcon: ContactEmergencyIcon,
  ContactPageIcon: ContactPageIcon,
  DesignServicesIcon: DesignServicesIcon,
  ContactsIcon: ContactsIcon,
  FireplaceIcon: FireplaceIcon,
  SettingsIcon: SettingsIcon,
  BarChartIcon: BarChartIcon,
  LocalShippingIcon: LocalShippingIcon,
  PollIcon: PollIcon,
  MenuBookIcon: MenuBookIcon,
  SettingsApplicationsIcon: SettingsApplicationsIcon,
  PhotoAlbumIcon: PhotoAlbumIcon,
  CardMembershipIcon: CardMembershipIcon,
  EmojiTransportationIcon: EmojiTransportationIcon,
  PhotoIcon: PhotoIcon,
  InfoIcon: InfoIcon,
  DirectionsCarIcon: DirectionsCarIcon,
  CategoryIcon: CategoryIcon,
  DevicesOtherIcon: DevicesOtherIcon,
  QueryStatsIcon: QueryStatsIcon,
  ReceiptIcon: ReceiptIcon,
  RuleIcon: RuleIcon,
  LineStyleIcon: LineStyleIcon,
  AppsIcon: AppsIcon,
  DynamicFormIcon: DynamicFormIcon,
  AutoGraphIcon: AutoGraphIcon,
  EqualizerIcon: EqualizerIcon,
  CalculateIcon: CalculateIcon,
  PsychologyIcon: PsychologyIcon,
  BuildOutlinedIcon: BuildOutlinedIcon,
  TourIcon: TourIcon,
  CelebrationIcon: CelebrationIcon,
  ContentPasteSearchIcon: ContentPasteSearchIcon,
  LocationCityIcon: LocationCityIcon,
  EngineeringIcon: EngineeringIcon,
  AddIcon: AddIcon,
  SearchIcon: SearchIcon,
  DescriptionIcon: DescriptionIcon,
  AddShoppingCartIcon: AddShoppingCartIcon,
  EventNoteIcon: EventNoteIcon,
  KeyboardReturnIcon: KeyboardReturnIcon,
  ContactSupportIcon: ContactSupportIcon,
  SmartToyIcon: SmartToyIcon,
  MoveToInboxIcon: MoveToInboxIcon,
  TravelExploreIcon: TravelExploreIcon,
  AltRouteIcon: AltRouteIcon,
  SupportAgentIcon: SupportAgentIcon,
  // Teklif Yonetimi (MENU_ID 36)
  ReceiptLongIcon: ReceiptLongIcon,
  RequestQuoteIcon: RequestQuoteIcon,
  // Hizmet/Iscilik (MENU_ID 25)
  GroupWorkIcon: GroupWorkIcon,
  TableChartIcon: TableChartIcon
};

function getPath(iconName) {
  if (iconPaths[iconName]) {
    return iconPaths[iconName];
  } else {
    return '';
  }
}

export const getMenu = () => {
  const MenuReturnData = [];

  let MenuCount = JSON.parse(sessionStorage.getItem('MenuData') || null);
  if (MenuCount === null) {
    MenuCount = JSON.parse(localStorage.getItem('MenuData') || null);
  }
  if (MenuCount === null || MenuCount === undefined) {
    return DefaultMenu;
  }
  if (MenuCount.length > 0) {
    const seenGroupHrefs = new Set();
    MenuCount.forEach(item => {
      if (item.href && seenGroupHrefs.has(item.href)) {
        return;
      }
      if (item.href) {
        seenGroupHrefs.add(item.href);
      }

      const seenItemHrefs = new Set();
      const items = item.items.filter(val => {
        if (val.href && seenItemHrefs.has(val.href)) {
          return false;
        }
        if (val.href) {
          seenItemHrefs.add(val.href);
        }
        return true;
      });

      MenuReturnData.push({
        title: item.title,
        href: item.href,
        icon: getPath(item.icon),
        items: items.map(val => ({
          title: val.title,
          href: val.href,
          icon: getPath(val.icon)
        }))
      });
    });
  } else {
    return DefaultMenu;
  }



  return MenuReturnData;
};

const DefaultMenu = [

  {
    title: 'Servis Açılış İşlemleri',
    href: '/OpenService1',
    icon: LockOpenOutlinedIcon,
    items: [
      {
        title: 'Yeni Talep Oluştur',
        icon: LibraryAddOutlinedIcon,
        href: '/OpenService'
      },
      {
        title: 'Onay Bekleyenler',
        icon: PassIcon,
        href: '/Confirm'
      },
      {
        title: 'Reddedilenler',
        icon: CancelScheduleSendOutlinedIcon,
        href: '/OpenReject'
      }
    ]
  },
  {
    title: 'Servis Kapanış İşlemleri',
    href: '/OpenService4',
    icon: LockOutlinedIcon,
    items: [
      {
        title: 'Yeni Talep Oluştur',
        icon: LibraryAddOutlinedIcon,
        href: '/CloseService'
      },
      {
        title: 'Onay Bekleyenler',
        icon: PassIcon,
        href: '/close/confirm'
      },
      {
        title: 'Reddedilenler',
        icon: CancelScheduleSendOutlinedIcon,
        href: '/CloseReject'
      }
    ]
  },
  {
    title: 'TSE-HYB Süreçleri',
    href: '/TseHybSurecleri',
    icon: LockOpenOutlinedIcon,
    items: [
      {
        title: 'Yetkili Servis Berat Yönetimi',
        icon: CardMembershipIcon,
        href: '/TseHybSurecleri'
      }
    ]
  },
  {
    title: 'Sms Yönetimi',
    href: '/SmsManagementDynamic',
    icon: SmsIcon,
    items: [
      {
        title: 'Sms Takip Sistemi',
        icon: MarkAsUnreadIcon,
        href: '/SmsManagementDynamic'
      }
    ]
  },
  {
    title: 'Organizasyon',
    href: '/Employee',
    icon: ApartmentIcon,
    items: [
      {
        title: 'Çalışan Yönetimi',
        icon: PersonIcon,
        href: '/Employee'
      },
      {
        title: 'Yetki Yönetimi',
        icon: AccessibilityIcon,
        href: '/Role'
      },
      {
        title: 'Çalışan Bilgileri',
        icon: ContactPageIcon,
        href: '/EmployeeInformation'
      },
      {
        title: 'Çalışan Çoklanan TC',
        icon: ContactEmergencyIcon,
        href: '/EmployeeMultipleUsedIdReport'
      },
      {
        title: 'Çalışan Kimlik Tarihçe',
        icon: BadgeIcon,
        href: '/EmployeeIdentifyReport'
      },
      {
        title: 'Çalışan Telefon Listesi',
        icon: SettingsPhoneIcon,
        href: '/EmployeePhoneList'
      },
      {
        title: 'Nakliye Montaj Servisleri',
        icon: ContactEmergencyIcon,
        href: '/JointService'
      }
    ]
  },
  {
    title: 'Enerji Çözümleri',
    href: '/HVAC',
    icon: FireplaceIcon,
    items: [
      {
        title: 'İşlemler',
        icon: SettingsIcon,
        href: '/HVAC'
      },
      {
        title: 'Raporlar',
        icon: AssessmentIcon,
        href: '/HVACReport'
      }
    ]
  },
  {
    title: 'Raporlar',
    href: '/report',
    icon: AssessmentIcon,
    items: [
      {
        title: 'Açılış Onay Raporu',
        icon: AssignmentIcon,
        href: '/report/openConfirm'
      },
      {
        title: 'Kapanış Onay Raporu',
        icon: AssignmentIcon,
        href: '/report/closeConfirm'
      }
    ]
  },
  {
    title: 'Model Muadil Raporu',
    href: '/MaterialEquivalentReport',
    icon: BarChartIcon,
    items: [
      {
        title: 'Model Muadil Raporu',
        icon: PollIcon,
        href: '/MaterialEquivalentReport'
      }
    ]
  },
  {
    title: 'Bayi Nakliye Katılım',
    href: '/DealerShippingPrices',
    icon: LocalShippingIcon,
    items: [
      {
        title: 'Bayi Nakliye Katılım',
        icon: LocalShippingIcon,
        href: '/DealerShippingPrices'
      }
    ]
  },
  {
    title: 'Ai Raporları',
    href: '/SestekAi',
    icon: BarChartIcon,
    items: [
      {
        title: 'Ai Görüşmeler',
        icon: PollIcon,
        href: '/SestekAi'
      },
      {
        title: 'Ai Raporlar',
        icon: PollIcon,
        href: '/SestekAiReport'
      }
    ]
  },
  {
    title: 'BPO Mutabakat Yönetimi',
    href: '/BpoMutabakat',
    icon: SupportAgentIcon,
    items: [
      {
        title: 'BPO Mutabakat',
        icon: AssessmentIcon,
        href: '/BpoMutabakat'
      }
    ]
  },
  {
    title: 'SARIS-Sorgular',
    href: '/SarisQueries',
    icon: QueryStatsIcon,
    items: [
      {
        title: 'Tekil Ürün Sorgu',
        icon: CategoryIcon,
        href: '/SarisQueries/IndividualProductInquiry'
      },
      {
        title: 'Rapor İzleme',
        icon: AssessmentIcon,
        href: '/SarisQueries/ReportMonitoring'
      },
      {
        title: 'Fiş Sorgu Toplu',
        icon: ReceiptIcon,
        href: '/SarisQueries/MultipleReceiptInquiry'
      },
      {
        title: 'Rapor İstek Ekranı',
        icon: AssessmentIcon,
        href: '/SarisQueries/ReportRequestScreen'
      }
    ]
  },
  {
    title: 'SARIS-Tanımlar',
    href: '/SarisDesc',
    icon: AppsIcon,
    items: [
      {
        title: 'Dinamik Ürünler',
        icon: CategoryIcon,
        href: '/SarisDesc/SarisDynamicProduct'
      },
      {
        title: 'Dinamik Garanti',
        icon: RuleIcon,
        href: '/SarisDesc/SarisDynamicWarranty'
      },
      {
        title: 'Dinamik Birim',
        icon: ApartmentIcon,
        href: '/SarisDesc/SarisDynamicUnit'
      },
      {
        title: 'Dinamik Hizmet,Arıza,İşçilik',
        icon: BuildOutlinedIcon,
        href: '/SarisDesc/SarisDynamicServiceLaborMaterial'
      },
      {
        title: 'Diğer Dinamik Tanımlar',
        icon: BuildOutlinedIcon,
        href: '/SarisDesc/SarisDynamicOther'
      },
      {
        title: 'Fcm Hessapla',
        icon: CalculateIcon,
        href: '/SarisDesc/SarisFcmCalculte'
      }
    ]
  },
  {
    title: 'Arçelik Servis Raporları',
    href: '/AsrReports',
    icon: AutoGraphIcon,
    items: [
      {
        title: 'Arçelik Servis Raporları',
        icon: EqualizerIcon,
        href: '/SarisQueries/IndividualProductInquiry'
      }
    ]
  },
  {
    title: 'Saha Uygulama Yönetimi',
    href: '/BannerApp',
    icon: SettingsApplicationsIcon,
    items: [
      {
        title: 'Banner Uygulama Yönetimi',
        icon: PhotoAlbumIcon,
        href: '/Banner'
      }
    ]
  },
  {
    title: 'Doğrulama Kuralları',
    href: '/RuleApp',
    icon: RuleIcon,
    items: [
      {
        title: 'Kural Yönetimi',
        icon: LineStyleIcon,
        href: '/Rule'
      }
    ]
  },
  {
    title: 'Kayıt Dışı İade',
    href: '/UnregisteredReturns',
    icon: KeyboardReturnIcon,
    items: [
      {
        title: 'Kayıt Dışı İade',
        icon: KeyboardReturnIcon,
        href: '/UnregisteredReturns'
      }
    ]
  },

  {
    title: 'Müşteri Hizmetleri Bütçe',
    href: '/AssemblyBudget',
    icon: CalculateIcon,
    items: [
      {
        title: 'İşçilik fiyat tahminleme',
        icon: PsychologyIcon,
        href: '/AssemblyBudget/LaborPriceEstimation'
      }
    ]
  },
  {
    title: 'Bayi Dış Teslim İl İlçe',
    href: '/LocationManagements',
    icon: LocationCityIcon,
    items: [
      {
        title: 'Bayi Dış Teslim İl İlçe',
        icon: LocationCityIcon,
        href: '/LocationManagement'
      }
    ]
  },
  {
    title: 'Bayi İş Emri',
    href: '/DealerWorkOrder',
    icon: AddShoppingCartIcon,
    items: [
      {
        title: 'Bayi İş Emri',
        icon: AddShoppingCartIcon,
        href: '/DealerWorkOrder'
      }
    ]
  },
  {
    title: 'Aron Rotam',
    href: '/AronRotam',
    icon: EventNoteIcon,
    items: [
      {
        title: 'Aron Rotam',
        icon: EventNoteIcon,
        href: '/AronRotam'
      }
    ]
  },
  {
    title: 'Servis İş Emri Sistemi',
    href: '/THWorkOrder',
    icon: EngineeringIcon,
    items: [
      {
        title: 'İş Emri Olustur',
        icon: AddIcon,
        href: '/CreateWorkOrder'
      },
      {
        title: 'İş Emri Sorgula',
        icon: SearchIcon,
        href: '/SearchWorkOrder'
      }
    ]
  },
  {
    title: 'Teknisyen Koçu',
    href: '/TeknisyenKocu',
    icon: DescriptionIcon,
    items: [
      {
        title: 'Teknisyen Koçu Sohbet',
        icon: SmartToyIcon,
        href: '/TeknisyenKocuSohbet'
      },
      {
        title: 'Görüşmeler',
        icon: ContactSupportIcon,
        href: '/TeknisyenKocuGorusme'
      }
    ]
  },
  {
    title: 'Döküman Yönetimi',
    href: '/FileManagement',
    icon: DescriptionIcon,
    items: [
      {
        title: 'Döküman',
        icon: DescriptionIcon,
        href: '/FileManagement'
      }
    ]
  },
  {
    title: 'Lojistik Takip',
    href: '/LogisticsTracking',
    icon: TravelExploreIcon,
    items: [
      {
        title: 'Arçelik Panel Onarım Servisine Ulaştırılacaklar',
        icon: LocalShippingIcon,
        href: '/LogisticsTracking/PanelRepairDeliveries'
      },
      {
        title: 'Arçelik Panel Onarım Servisinden Teslim Alınacaklar',
        icon: MoveToInboxIcon,
        href: '/LogisticsTracking/PanelServicePickups'
      }
    ]
  },
  {
    title: text('Kullanici'),
    href: '/profile',
    icon: PersonIcon,
    items: [
      {
        title: 'Kullanıcı',
        icon: PersonIcon,
        href: '/profile/1/timeline'
      }
    ]
  },
  {
    title: 'Mesajlaşma',
    href: '/Chat',
    icon: CommentIcon
  },
  {
    title: 'Yardım',
    href: '/Help',
    icon: HelpIcon
  }
];
